// @flow

import React from 'react';
import i18n from 'app/common/lib/i18n';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';
import { Box } from 'gestalt';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';

type Props = {|
  followerCount?: number,
  followText: string,
  isHorizontalDesign: boolean,
  userFollowed?: boolean,
  showFollowers: ?boolean,
|};

export default function AvatarHoverCardFollowingText({
  followText,
  followerCount,
  isHorizontalDesign,
  showFollowers,
  userFollowed,
}: Props) {
  if (showFollowers) {
    return interpolateNamedTemplate(i18n._('{{ followCount }} {{ followText }}'), {
      followCount: (
        <Box
          dangerouslySetInlineStyle={{ __style: !userFollowed ? { opacity: 0.75 } : null }}
          data-test-id="followCount"
          display="inlineBlock"
          key="followCount"
          marginRight={1}
        >
          <Text
            color={userFollowed ? 'gray' : 'white'}
            size={isHorizontalDesign ? 'sm' : 'md'}
            align="center"
            weight="semibold"
          >
            <PrettyNumber value={followerCount || 0} shortform shortformMaximumFractionDigits={0} />
          </Text>
        </Box>
      ),
      followText: (
        <Box data-test-id="followText" display="inlineBlock" key="followText">
          <Text
            weight="bold"
            color={userFollowed ? 'darkGray' : 'white'}
            size={isHorizontalDesign ? 'sm' : 'md'}
            overflow="normal"
            align="center"
          >
            {followText}
          </Text>
        </Box>
      ),
    });
  } else {
    return (
      <Box data-test-id="followText" key="followText">
        <Text
          weight="semibold"
          color={userFollowed ? 'darkGray' : 'white'}
          size={isHorizontalDesign ? 'sm' : 'md'}
          overflow="normal"
          align="center"
        >
          {followText}
        </Text>
      </Box>
    );
  }
}
